/**
 * @module manifest/upload-keys
 * @description 上传字段映射（由 `groupRegistryDefs/allGroups` 的 defineGroup 声明派生）
 *
 * - **组级** `CONFIG_ITEM_UPLOAD_KEYS`（default）：panelLayout 组 id → 字段；
 *   `convert()` 收集、整组隐藏时的 formDelKey。
 * - **子项级** `CONFIG_GROUP_ITEM_UPLOAD_KEYS`：组 id → 子项 id → 字段；
 *   仅 `evaluateVisibility` 在子项 `itemsVisibility` 隐藏时使用。
 */

import {
  definitionsToGroupItemUploadKeys,
  definitionsToUploadKeys,
} from './defineGroup';
import { REGISTERED_GROUP_DEFS } from './groupRegistryDefs';

/** 组内子项 → 上传字段（勿与组级平铺重复子项 id） */
export const CONFIG_GROUP_ITEM_UPLOAD_KEYS = definitionsToGroupItemUploadKeys(
  REGISTERED_GROUP_DEFS,
);

/** 配置项组 id → 上传字段 */
const CONFIG_ITEM_UPLOAD_KEYS = definitionsToUploadKeys(REGISTERED_GROUP_DEFS);

export default CONFIG_ITEM_UPLOAD_KEYS;
